/* eslint-disable no-confusing-arrow */
/* eslint-disable implicit-arrow-linebreak */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'react-final-form-arrays';
import FormFieldArray from '../FormFieldArray';
import RenderFieldArrayComponent from './RenderFieldArrayComponent';
import { requiredFieldArray } from '../../../../utils/utils';

const propTypes = {
  fieldValues: PropTypes.object,
  showHelpeIcon: PropTypes.bool,
  fieldName: PropTypes.string,
  controlledVocab: PropTypes.object,
  actionType: PropTypes.string,
};

function FieldArrayComponent({
  fieldValues,
  showHelpeIcon,
  fieldName,
  controlledVocab,
  actionType,
}) {
  const { fieldArray, isRepeatable, isRequired } = fieldValues;
  const [initArray, setInitArray] = useState(null);

  useEffect(() => {
    if (!isRepeatable) {
      const fieldObj = {};
      fieldArray.forEach((key) => {
        fieldObj[key.name] = '';
      });
      setInitArray([fieldObj]);
    } else {
      setInitArray(null);
    }
  }, [isRepeatable]);

  return (
    <FieldArray
      id={`form-fields-generator-array-field-type-${fieldValues.name}`}
      name={fieldName}
      component={FormFieldArray}
      RenderFieldComponent={RenderFieldArrayComponent}
      fieldValues={fieldValues}
      showHelpeIcon={showHelpeIcon}
      validate={isRequired ? requiredFieldArray : () => undefined}
      controlledVocab={controlledVocab}
      actionType={actionType}
    />
  );
}

FieldArrayComponent.propTypes = propTypes;

export default FieldArrayComponent;
